import { GridColDef } from '@mui/x-data-grid';

import { CvUploadWidget } from '../../../DerivedCharts/helper';
import { IPostgreCvUploadDTO } from '../../jobs/types/postgreJobsDTO';

export const getCvUploadTableData = (
  widgetName: CvUploadWidget,
  widgetData: IPostgreCvUploadDTO
) => {
  const uniqueDates = Array.from(
    new Set(widgetData.resultSet?.flatMap((record) => Object.keys(record.countsByDate ?? {})))
  );
  let columns: GridColDef<any, any, any>[];
  switch (widgetName) {
    case CvUploadWidget.TABLE_RECRUITER: {
      columns = [
        { field: 'recruiterName', headerName: 'Recruiter Name', width: 180 },
        {
          field: 'successCount',
          headerName: `Success(${widgetData.totalSuccess ?? 0})`,
          width: 150,
        },
        { field: 'failedCount', headerName: `Failed(${widgetData.totalFailed ?? 0})`, width: 150 },
        {
          field: 'processingCount',
          headerName: `Processing(${widgetData.totalProcessing ?? 0})`,
          width: 150,
        },
        { field: 'count', headerName: `Total Count(${widgetData.totalCount ?? 0})`, width: 150 },
        ...uniqueDates.map((date) => ({
          field: date,
          headerName: date,
          width: 110,
        })),
      ];
      break;
    }
    default:
      throw new Error("Invalid 'CvUpload Table Widget' type");
  }

  const rows = widgetData.resultSet?.map((record, index) => {
    const row = {
      id: index,
      recruiterName: record.recruiterName,
      successCount: record.successCount,
      failedCount: record.failedCount,
      processingCount: record.processingCount,
      count: record.count,
    };

    uniqueDates.forEach((date) => {
      row[date] = record.countsByDate?.[date] || 0;
    });

    return row;
  });

  return [rows, columns];
};

export const defaultCvUploadWidgetData: IPostgreCvUploadDTO = {
  totalCount: 0,
  totalFailed: 0,
  totalSuccess: 0,
  totalProcessing: 0,
  response: [],
  resultSet: [],
  series: [],
  categories: [],
};
